import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';

export interface NameBadgeProps extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  name?: string | null;
  variant?: 'default' | 'custom';
  size?: 'sm' | 'md' | 'lg';
  textOpacity?: number;
  children?: ReactNode;
}

export function NameBadge({
  name,
  variant = 'default',
  size = 'md',
  children,
  ...props
}: NameBadgeProps) {
  const className = classNames(
    'inline-flex overflow-hidden relative justify-center items-center rounded-full text-sm font-medium text-black/70',
    variant === 'default' && 'bg-emerald-100',
    size === 'sm' && 'w-6 h-6',
    size === 'md' && 'w-8 h-8',
    size === 'lg' && 'w-10 h-10',
    props.className,
  );

  return (
    <span {...props} className={className}>
      {name?.slice(0, 1).toUpperCase()}
      {children}
    </span>
  );
}
